import React, { useState, useEffect, useRef } from "react";
import {
  Dashboard,
  MonthlyTourPlanning,
  MarketWorking,
  MyWssCounts,
  MyDealerCount,
} from "@features/home";
import { Header } from "@features/profile";
import { DivisionGroup } from "@features/shared";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { initializeEventListeners } from "@components/Common/Function";
import {
  getBarGraph,
  getMarketWorking,
} from "@redux/actions/homePage-actions";
import {
  getCheckInDealerDetails,
  getCheckInWSSDetails,
} from "@redux/actions/checkinDetails-actions";
import { getPastSrDetails } from "@redux/actions/pastInsights-actions";
import { getUpcomingTourPlan } from "@redux/actions/upcomingTourPlan-actions";
import { getFeedbackDetails } from "@redux/actions/getFeedback-action";
import { getMyUserFeedback } from "@redux/actions/myuser-actions";

// LCD visit-frequency reminder (scope §5.3) is paused — pending a tighter
// BM↔LCD filter (current salesgroup-only join over-counts; needs Salesforce
// dealer-list intersection per BM). To re-enable: restore the useEffect that
// calls lcdSurveyService.getReminder + render <LcdReminderModal />.

function HomepagePage() {
  const dispatch = useDispatch();
  const expiryTime = useSelector((state) => state?.tokens?.creationDate);
  const eventCountRef = useRef(0);
  const hasEventListeners = useRef(false);
  const [showModal, setShowModal] = useState(false);

  const userType = useSelector(
    (state) => state?.userDetails?.details?.Profile?.Name
  );

  const salesGroupCode = useSelector(
    (state) => state?.userDetails?.details?.Sales_Group_Code__c
  );

  const division = useSelector(
    (state) => state?.userDetails?.details?.Division
  );

  const HO_Role__c = useSelector((state) => state?.userType?.type);

  const userTypeAndRole = useSelector((state) =>
    state?.userType?.type !== "Other"
      ? state?.userType?.type
      : state?.userDetails?.details?.Title
  );

  const isAuthenticated = useSelector((state) => state?.tokens?.isAuthenticated);

  // Fetch Homepage-specific data when component mounts (only when authenticated)
  useEffect(() => {
    if (!isAuthenticated) return;
    dispatch(getBarGraph());
    dispatch(getMarketWorking());
    dispatch(getUpcomingTourPlan());
    dispatch(getCheckInDealerDetails());
    dispatch(getCheckInWSSDetails());
    dispatch(getPastSrDetails());
    dispatch(getFeedbackDetails());
    dispatch(getMyUserFeedback());
  }, [dispatch, isAuthenticated]);

  useEffect(() => {
    let pop_status = localStorage.getItem("pop_status");
    if (!_.isEmpty(userType) && !_.isEmpty(HO_Role__c)) {
      if (HO_Role__c === "RBDM Collaborator" || HO_Role__c === "MH3") {
        setShowModal(false);
      } else if (
        userTypeAndRole &&
        !pop_status &&
        (userTypeAndRole === "HO Collaborator" ||
          userTypeAndRole === "SH7" ||
          userTypeAndRole === "HO Auditor" ||
          userTypeAndRole === "TMM") &&
        (!salesGroupCode || division == 70 || division == 30 || (userTypeAndRole === "TMM" && !!division))
      ) {
        setShowModal(true);
        localStorage.setItem("pop_status", 1);
      } else {
        setShowModal(false);
      }
    }
  }, [userType, salesGroupCode, division, HO_Role__c, userTypeAndRole]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const cleanup = initializeEventListeners(
      expiryTime,
      dispatch,
      eventCountRef,
      hasEventListeners
    );
    return cleanup;
  }, [expiryTime, dispatch]);

  return (
    <div className="flex flex-col items-center justify-center mb-16 container p-0">
      <Header />
      <>
        <Dashboard />
        <MonthlyTourPlanning />
        <MarketWorking />
        {userTypeAndRole === "SH3" && (
          <>
            <MyWssCounts />
            <MyDealerCount />
          </>
        )}
      </>
      {showModal && (
        <DivisionGroup
          setIsDivisionGroupClicked={(value) => {
            if (!value) setShowModal(false);
          }}
        />
      )}
    </div>
  );
}

export default HomepagePage;
